// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import productReducer from './reducers/productSlice'; // 使用 productSlice
import orderReducer from './orderSlice'; // 新增订单 reducer


const store = configureStore({
  reducer: {
    user: userReducer, // 已有 user 命名空间
    products: productReducer, // 新增 products 命名空间
    orders: orderReducer, // 新增订单 reducer
  },
});

export default store;